import { render } from "./LiquidityPools.vue?vue&type=template&id=7af9b395"
import script from "./LiquidityPools.vue?vue&type=script&lang=js"
export * from "./LiquidityPools.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/defi/LiquidityPools.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7af9b395"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7af9b395', __exports__)) {
    api.reload('7af9b395', __exports__)
  }
  
  module.hot.accept("./LiquidityPools.vue?vue&type=template&id=7af9b395", () => {
    api.rerender('7af9b395', render)
  })

}


export default __exports__